import React, { useEffect, useCallback } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import moment from 'moment';
import numeral from 'numeral';
import styles from './BillCreditDetail.module.css';
import { ReactComponent as PrevSVG } from '../../Assets/icons/prev.svg';
import DetailField from '../ReusableComponents/DetailField/DetailField';
import Page from '../Page';
import Header from '../Header';
import VendorsDataGrid from '../VendorBillDetail/VendorBillDetailDataGrid';
import { BillCredit } from '../../Lib/Api/vendor';

interface BillCreditDetailProps
  extends RouteComponentProps<{ id: string; billCreditId: string }> {
  billCredit: BillCredit;
  getBillCredit: (id: string, billCreditId: string) => void;
}

function BillCreditDetail({
  match,
  billCredit,
  getBillCredit,
}: BillCreditDetailProps) {
  const history = useHistory();
  const { id, billCreditId } = match.params;

  useEffect(() => {
    getBillCredit(id, billCreditId);
  }, [getBillCredit, id, billCreditId]);

  const handleBackClick = useCallback(() => {
    if (history.length > 2) {
      history.goBack();
    } else {
      history.push(`/users/${id}/credits`);
    }
  }, [history, id]);

  const {
    items,
    reference_number: referenceNumber,
    memo,
    amount,
    date,
  } = billCredit;

  if (!referenceNumber) {
    return null;
  }

  return (
    <Page.Container>
      <Header.Major
        icon="credit-card/credit-card-arrow-left"
        title="Credits"
        subTitle={referenceNumber}
        onCloseLink={`/users/${id}/credits`}
      />
      <Page.Content>
        <div className={styles.row}>
          <DetailField label="Date">
            <span>{moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY')}</span>
          </DetailField>
          <DetailField label="Memo">
            <span>{memo}</span>
          </DetailField>
          <DetailField label="Amount">
            <span>{numeral(amount).format('$0,0.00')}</span>
          </DetailField>

          <div className={styles.halfRow} />
        </div>

        <VendorsDataGrid rows={items} isBillCredit />
        <p className={styles.subText}>
          Updates will not be reflected for up to 5 minutes
        </p>

        <div className={styles.buttonRow}>
          <PrevSVG
            height="15"
            width="40"
            className={styles.buttonPreviousSvg}
            onClick={handleBackClick}
          />
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/click-events-have-key-events */}
          <p
            id="bcd-detail-back"
            className={styles.buttonPrevious}
            onClick={handleBackClick}
          >
            PREVIOUS
          </p>
        </div>
      </Page.Content>
    </Page.Container>
  );
}

export default BillCreditDetail;
